import { adjust, mediumLayout } from '@chegg-wt/core/theme/theme'
import FantaTheme from '@chegg-wt/core/theme/fanta/theme'
import styled, { css } from 'styled-components'
import { SVP_VARIANT_ONE, SVP_VARIANT_TWO } from '.'

export const SvpTopWrapper = styled.div<{ variant?: string }>`
  min-height: 90px;
  @media (min-width: ${({ theme }) => mediumLayout(theme)}) {
    display: flex;
    justify-content: center;
    height: ${(props) => (props.variant === SVP_VARIANT_TWO ? '90px' : '')};
  }
  ${({ variant }) =>
    variant === SVP_VARIANT_ONE &&
    css`
      @media (min-width: ${({ theme }) => mediumLayout(theme)}) {
        display: none;
      }
    `}
`

export const SvpHideWrapperT2 = styled.div<{ variant?: string }>`
  @media (max-width: ${({ theme }) => adjust(mediumLayout(theme), -1)}) {
    display: none;
  }
  ${({ variant }) =>
    variant === SVP_VARIANT_TWO &&
    css`
      @media (min-width: ${({ theme }) => mediumLayout(theme)}) {
        display: none;
      }
    `}
`

export const WelcomeBanner = styled.div`
  font-size: ${FantaTheme.font.text.size.md};
  background-color: ${FantaTheme.colors.royalLight};
  color: #000000;
  line-height: 1.25rem;
  display: flex;
  align-items: center;
  text-align: center;
  justify-content: center;
  padding: ${FantaTheme.spacing.fanta.sm};
  width: 100%;
`
